module.exports = __webpack_public_path__ + "static/media/04n.521cfa4d.svg";